import { useIntl } from "react-intl";
import { AuxiaResponse } from "src/pages/software/jira/service-management/auxia/get-auxia-jsm-paid-lp-treatment";
import { isAuxiaServedPage } from "src/pages/software/jira/service-management/auxia/is-auxia-served-page";
import {
    convertDateTimeToInteractionTimeMicros,
    sendAnalyticsToAuxia
} from "src/pages/software/jira/service-management/auxia/send-analytics-to-auxia";

import { Adg4Button } from "@/components/adg4/button/src";
import { useAccountCreationContext } from "@/components/signup/account-creation";
import { Cookie } from "@/utils/cookie";

export const AuxiaSubmit = ({
    buttonText,
    auxiaResponse
}: {
    buttonText?: string;
    auxiaResponse?: AuxiaResponse | null;
}) => {
    const intl = useIntl();

    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    if (buttonText === undefined) {
        buttonText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.submit",
            defaultMessage: "Sign up"
        });
    }

    return (
        <Adg4Button
            type="submit"
            isDisabled={isSubmitting || (hasSubmitted && !formError)}
            isFullWidth={true}
            isLoading={isSubmitting || (hasSubmitted && !formError)}
            onClick={() => {
                if (isAuxiaServedPage(auxiaResponse)) {
                    const anonymousId = decodeURIComponent(
                        Cookie.readCookie("ajs_anonymous_id") || ""
                    ).replace(/['"]+/g, "");

                    sendAnalyticsToAuxia({
                        anonymousId: anonymousId,
                        treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                        treatmentId: auxiaResponse.treatmentId,
                        interactionType: "CLICKED",
                        interactionTimeMicros:
                            convertDateTimeToInteractionTimeMicros(Date.now()),
                        actionName: "sign_up"
                    });
                }

                return onClickSubmitButton();
            }}
        >
            {buttonText}
        </Adg4Button>
    );
};
